import { Body, H2 } from '@/components/atoms/typography'
import { Flex } from '@/components/atoms/Grid'
import { FC } from 'react'
import styled from 'styled-components'
import { MediaContextProvider } from '../atoms/media'

type ProductListingTitleCountInfoProps = {
  title: string
  additionalInfo?: string
} & Rest

const ProductListingTitleCountInfo: FC<ProductListingTitleCountInfoProps> = ({
  title,
  additionalInfo,
  ...rest
}) => {
  return (
    <MediaContextProvider>
      <StyledFlex
        alignItems="center"
        justifyContent="space-between"
        className="test"
      >
        <Flex
          flexDirection={{
            desktop: 'row',
            tablet: 'row',
            mobile: 'column'
          }}
          alignItems={{
            desktop: 'center',
            tablet: 'center',
            mobile: 'flex-start'
          }}
          my={{
            desktop: 20,
            tablet: 18,
            mobile: 12
          }}
          {...rest}
        >
          <StyledTitle my={0} mr={14}>
            {title}
          </StyledTitle>
          {additionalInfo && (
            <StyledAdditionalInfo>{additionalInfo}</StyledAdditionalInfo>
          )}
        </Flex>
      </StyledFlex>
    </MediaContextProvider>
  )
}

export default ProductListingTitleCountInfo

const StyledFlex = styled(Flex)`
  max-width: calc(100% - 45px);
`

const StyledAdditionalInfo = styled(Body)`
  opacity: 0.6;
  margin: 0;
  line-height: normal;
`

const StyledTitle = styled(H2)`
  margin: 0 14px 0 0;
  line-height: normal;
`
